import { render, staticRenderFns } from "./truck-form-edit.vue?vue&type=template&id=286b4ec6&scoped=true&"
import script from "./truck-form-edit.vue?vue&type=script&lang=js&"
export * from "./truck-form-edit.vue?vue&type=script&lang=js&"
import style0 from "./truck-form-edit.vue?vue&type=style&index=0&id=286b4ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b4ec6",
  null
  
)

export default component.exports